import { signOut } from '@modules/supabase/supabase-config';
import { Box, Button } from '@mui/material';
import { logError } from '@utils/logging';
import React, { Component, ReactNode } from 'react';

interface Props {
    children?: ReactNode | ReactNode[] | undefined;
    location: string;
}

interface State {
    hasError: boolean;
}

export default class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(/* error: any */) {
        return { hasError: true };
    }

    componentDidUpdate(prevProps: Props) {
        const { location } = this.props;
        if (location !== prevProps.location) this.setState({ hasError: false });
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.warn('ErrorBoundary', { error: error, errorInfo: errorInfo });
        logError(new Error(`${error.message} ${this.props.location} ${errorInfo.componentStack}`));
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <Box alignItems="center" display="flex" flexDirection="column" padding={10}>
                    <h1>Something went wrong.</h1>
                    <h3>We've logged the error and will look into it. Please come back later.</h3>
                    <div style={{ marginTop: '2rem' }}>
                        {history.length > 1 ? (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => history.back()}
                                style={{ marginRight: '1rem' }}
                                size="large"
                            >
                                Go Back
                            </Button>
                        ) : null}
                        <Button
                            variant="outlined"
                            color="primary"
                            style={{ marginRight: '1rem' }}
                            onClick={() => location.reload()}
                            size="large"
                        >
                            Reload Page
                        </Button>
                        <Button variant="outlined" color="error" onClick={signOut} size="large">
                            Log Out
                        </Button>
                    </div>
                </Box>
            );
        }
        return this.props.children;
    }
}
